module.exports = {
    FIRST_MESSAGE_POPUP_IS_SHOWN: 'first_message_popup_is_shown',
    CLICKED_ON_ADD_ATTACHMENT_TO_MESSAGE: 'clicked_on_add_attachment_to_message',
    CLICKED_ON_ADD_EMOJI_ICON_IN_POPUP_MESSAGE: 'clicked_on_add_emoji_icon_in_popup_message',
    CLICKED_ON_QUICK_RESPONSE: 'clicked_on_quick_response',
    CLICKED_ON_SEND_MESSAGE: 'clicked_on_send_message',
    CLICKED_ON_X_BUTTON: 'clicked_on_x_button',
    CLICKED_ON_LEAVE_POP_UP_MESSAGE: 'clicked_on_leave_pop_up_message',
    CLICKED_ON_STAYING_IN_POP_UP_MESSAGE: 'clicked_on_staying_in_pop_up_message',
    WARNING_MESSAGE_SHOW: 'warning_message.show',
    POST_FIRST_MESSAGE_POP_UP_IS_SHOWN: 'post_first_message_pop_up_is_shown',
    CLICK_SEND_MESSAGE_POST_FIRST_MESSAGE_POP_UP: 'click_send_message_post_first_message_pop_up',
    CLICK_GO_TO_INBOX_POST_FIRST_MESSAGE_POP_UP: 'click_go_to_inbox_post_first_message_pop_up',
    CLICK_TOGGLE_MESSAGE_POST_FIRST_MESSAGE_POP_UP: 'click_toggle_message_post_first_message_pop_up',
    DISMISS_OFFER_MORE_GIGS: 'dismiss_offer_more_gigs',
    REQUEST_TO_ORDER_MODAL_IS_SHOWN: 'request_to_order_modal_is_shown',
    CLICK_ON_SUBMIT_REQUEST_BUTTON: 'clicked_on_submit_a_request_button',
    APP_DOWNLOAD_MODAL_IS_SHOWN: 'app_download_modal_is_shown',
    MESSAGE_SENT_MODAL_IS_SHOWN: 'message_sent_modal_is_shown',
    CLICKED_ON_VIEW_MESSAGE: 'clicked_on_view_message',
    QUICK_QUESTIONS_VIEW_IS_SHOWN: 'fmp_quick_response_panel_is_shown',
    BRIEF_BUTTON_IS_SHOWN: 'professional_brief_button_shown',
    SATISFACTION_GUARANTEE_IS_SHOWN: 'customer_protection_banner_is_shown',
    BRIEF_BUTTON_IS_CLICKED: 'professional_brief_button_clicked'
};
